import { resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createVNode as _createVNode, toDisplayString as _toDisplayString, vShow as _vShow, withDirectives as _withDirectives, Fragment as _Fragment } from "vue"
import _imports_0 from '@/app/ui/assets/svg/arrow-left.svg'


const _hoisted_1 = { class: "flex flex-row justify-between items-center border-b border-gray-lp-400" }
const _hoisted_2 = { class: "flex flex-row my-4" }
const _hoisted_3 = { class: "font-semibold text-20px mr-4 text-black-lp-200" }
const _hoisted_4 = { class: "inline-flex" }
const _hoisted_5 = {
  key: 1,
  class: "flex flex-row py-6 h-screen overflow-y-auto"
}
const _hoisted_6 = { class: "w-2/3 px-4 text-12px xxl:text-14px" }
const _hoisted_7 = { class: "py-3 w-3/4" }
const _hoisted_8 = { class: "font-semibold text-black-lp-300" }
const _hoisted_9 = { class: "flex flex-row w-3/4" }
const _hoisted_10 = { class: "py-3 w-1/2 mr-4" }
const _hoisted_11 = { class: "font-semibold text-black-lp-300" }
const _hoisted_12 = { class: "py-3 w-1/2" }
const _hoisted_13 = { class: "font-semibold text-black-lp-300" }
const _hoisted_14 = { class: "inline-block flex flex-row" }
const _hoisted_15 = { class: "bg-gray-lp-900 text-center my-1 opacity-50 items-center py-2 text-12px xxl:text-14px px-2" }
const _hoisted_16 = { class: "flex flex-row w-3/4" }
const _hoisted_17 = { class: "py-3 w-1/2 mr-4" }
const _hoisted_18 = { class: "font-semibold text-black-lp-300" }
const _hoisted_19 = { class: "py-3 w-1/2" }
const _hoisted_20 = { class: "font-semibold text-black-lp-300" }
const _hoisted_21 = { class: "py-3 w-3/4" }
const _hoisted_22 = { class: "font-semibold text-black-lp-300" }
const _hoisted_23 = { class: "flex flex-col h-full text-12px border-t border-gray-lp-400 my-6 py-6" }
const _hoisted_24 = { class: "py-3" }
const _hoisted_25 = { class: "font-semibold text-black-lp-300" }
const _hoisted_26 = { class: "my-1 text-gray-lp-500 max-w-md" }
const _hoisted_27 = { class: "flex flex-row text-12px xxl:text-14px items-center text-black-lp-300" }
const _hoisted_28 = /*#__PURE__*/_createVNode("div", { class: "toggle-knob bg-white inline-block" }, null, -1)
const _hoisted_29 = { class: "ml-4" }
const _hoisted_30 = { class: "w-1/3 px-8 text-12px xxl:text-14px border-l border-gray-lp-400" }
const _hoisted_31 = { class: "py-3" }
const _hoisted_32 = { class: "font-semibold text-black-lp-300" }
const _hoisted_33 = { class: "my-1 text-black-lp-300" }
const _hoisted_34 = { class: "flex" }
const _hoisted_35 = { class: "py-3" }
const _hoisted_36 = { class: "font-semibold text-black-lp-300" }
const _hoisted_37 = { class: "my-1 text-black-lp-300" }
const _hoisted_38 = { class: "text-gray-lp-500" }
const _hoisted_39 = { class: "py-3" }
const _hoisted_40 = { class: "font-semibold text-black-lp-300" }
const _hoisted_41 = { class: "my-1 text-black-lp-300" }
const _hoisted_42 = { class: "text-gray-lp-500" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_PageDetailLazyLoad = _resolveComponent("PageDetailLazyLoad")!
  const _component_button_fill = _resolveComponent("button-fill")!
  const _component_ErrorMessage = _resolveComponent("ErrorMessage")!
  const _component_Modal = _resolveComponent("Modal")!

  return (_openBlock(), _createBlock(_Fragment, null, [
    (_ctx.isLoading)
      ? (_openBlock(), _createBlock(_component_PageDetailLazyLoad, {
          key: 0,
          onBack: _ctx.goBack
        }, null, 8, ["onBack"]))
      : (_openBlock(), _createBlock(_Fragment, { key: 1 }, [
          _createVNode("div", _hoisted_1, [
            _createVNode("div", _hoisted_2, [
              _createVNode("img", {
                src: _imports_0,
                onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.goBack && _ctx.goBack(...args))),
                class: "w-5 mr-3 cursor-pointer",
                alt: "back"
              }),
              _createVNode("div", _hoisted_3, _toDisplayString(_ctx.$t("userManagement.edit.title")), 1)
            ]),
            _createVNode("div", _hoisted_4, [
              _withDirectives(_createVNode(_component_button_fill, {
                title: _ctx.$t('userManagement.edit.save'),
                onClick: _ctx.onOpenSave,
                class: "px-8 bg-red-lp-300"
              }, null, 8, ["title", "onClick"]), [
                [_vShow, !_ctx.isError]
              ])
            ])
          ]),
          (_ctx.isError)
            ? (_openBlock(), _createBlock(_component_ErrorMessage, {
                key: 0,
                errorType: _ctx.errorCause,
                onTryAgain: _ctx.fetchUserData
              }, null, 8, ["errorType", "onTryAgain"]))
            : (_openBlock(), _createBlock("div", _hoisted_5, [
                _createVNode("div", _hoisted_6, [
                  _createVNode("div", _hoisted_7, [
                    _createVNode("div", _hoisted_8, _toDisplayString(_ctx.$t("userManagement.edit.username")), 1),
                    _createVNode("input", {
                      type: "text",
                      placeholder: _ctx.dataDetail.username,
                      class: 
              `py-1.5 xxl:py-3 px-4 rounded border border-gray-lp-400 focus:outline-none focus:shadow my-1 text-black-lp-300 w-full ${_ctx.isDisabled &&
                'bg-white'}`
            ,
                      disabled: _ctx.isDisabled
                    }, null, 10, ["placeholder", "disabled"])
                  ]),
                  _createVNode("div", _hoisted_9, [
                    _createVNode("div", _hoisted_10, [
                      _createVNode("div", _hoisted_11, _toDisplayString(_ctx.$t("userManagement.edit.email")), 1),
                      _createVNode("input", {
                        type: "text",
                        placeholder: _ctx.dataDetail.email,
                        class: 
                `py-1.5 xxl:py-3 px-4 rounded border border-gray-lp-400 focus:outline-none focus:shadow my-1 text-black-lp-300 w-full ${_ctx.isDisabled &&
                  'bg-white'}`
              ,
                        disabled: _ctx.isDisabled
                      }, null, 10, ["placeholder", "disabled"])
                    ]),
                    _createVNode("div", _hoisted_12, [
                      _createVNode("div", _hoisted_13, _toDisplayString(_ctx.$t("userManagement.edit.phoneNumber")), 1),
                      _createVNode("div", _hoisted_14, [
                        _createVNode("div", _hoisted_15, _toDisplayString(_ctx.phonePrefix), 1),
                        _createVNode("input", {
                          type: "text",
                          placeholder: _ctx.dataDetail.phone_number,
                          class: 
                  `py-1.5 xxl:py-3 px-4 rounded border border-gray-lp-400 focus:outline-none focus:shadow my-1 text-black-lp-300 w-full ${_ctx.isDisabled &&
                    'bg-white'}`
                ,
                          disabled: _ctx.isDisabled
                        }, null, 10, ["placeholder", "disabled"])
                      ])
                    ])
                  ]),
                  _createVNode("div", _hoisted_16, [
                    _createVNode("div", _hoisted_17, [
                      _createVNode("div", _hoisted_18, _toDisplayString(_ctx.$t("userManagement.edit.accountType")), 1),
                      _createVNode("input", {
                        type: "text",
                        placeholder: _ctx.dataDetail.account_type,
                        class: 
                `py-1.5 xxl:py-3 px-4 rounded border border-gray-lp-400 focus:outline-none focus:shadow my-1 text-black-lp-300 w-full ${_ctx.isDisabled &&
                  'bg-white'}`
              ,
                        disabled: _ctx.isDisabled
                      }, null, 10, ["placeholder", "disabled"])
                    ]),
                    _createVNode("div", _hoisted_19, [
                      _createVNode("div", _hoisted_20, _toDisplayString(_ctx.$t("userManagement.edit.role")), 1),
                      _createVNode("input", {
                        type: "text",
                        placeholder: _ctx.dataDetail.role_name,
                        class: 
                `py-1.5 xxl:py-3 px-4 rounded border border-gray-lp-400 focus:outline-none focus:shadow my-1 text-black-lp-300 w-full ${_ctx.isDisabled &&
                  'bg-white'}`
              ,
                        disabled: _ctx.isDisabled
                      }, null, 10, ["placeholder", "disabled"])
                    ])
                  ]),
                  _createVNode("div", _hoisted_21, [
                    _createVNode("div", _hoisted_22, _toDisplayString(_ctx.$t("userManagement.edit.reference")), 1),
                    _createVNode("input", {
                      type: "text",
                      placeholder: 
              _ctx.dataDetail.client !== undefined
                ? _ctx.dataDetail.client.company_name
                : _ctx.dataDetail.partner !== undefined
                ? _ctx.dataDetail.partner.name
                : _ctx.dataDetail.vendor !== undefined
                ? _ctx.dataDetail.vendor.name
                : ' '
            ,
                      class: 
              `py-1.5 xxl:py-3 px-4 rounded border border-gray-lp-400 focus:outline-none focus:shadow my-1 text-black-lp-300 w-full ${_ctx.isDisabled &&
                'bg-white'}`
            ,
                      disabled: _ctx.isDisabled
                    }, null, 10, ["placeholder", "disabled"])
                  ]),
                  _createVNode("div", _hoisted_23, [
                    _createVNode("div", _hoisted_24, [
                      _createVNode("div", _hoisted_25, _toDisplayString(_ctx.$t("userManagement.edit.accountStatus")), 1),
                      _createVNode("div", _hoisted_26, _toDisplayString(_ctx.$t("userManagement.edit.accountStatusDescription")), 1)
                    ]),
                    _createVNode("div", _hoisted_27, [
                      _createVNode("div", {
                        onClick: _cache[2] || (_cache[2] = () => _ctx.onOpenRoute()),
                        class: 
                `toggle-switch inline-block cursor-pointer ${
                  _ctx.isRoute() ? 'toggle-active bg-red-lp-100' : 'bg-gray-lp-200'
                }`
              
                      }, [
                        _hoisted_28
                      ], 2),
                      _createVNode("div", _hoisted_29, _toDisplayString(_ctx.isRoute()
                  ? _ctx.$t("userManagement.edit.accountActive")
                  : _ctx.$t("userManagement.edit.accountInactive")), 1)
                    ])
                  ])
                ]),
                _createVNode("div", _hoisted_30, [
                  _createVNode("div", _hoisted_31, [
                    _createVNode("div", _hoisted_32, _toDisplayString(_ctx.$t("userManagement.edit.statusUser")), 1),
                    _createVNode("div", _hoisted_33, [
                      _createVNode("div", _hoisted_34, [
                        _createVNode("div", {
                          class: 
                  `rounded-full px-2 py-0 font-medium ${
                    _ctx.isRoute() ? 'bg-green-lp-300' : 'bg-red-lp-600'
                  } ${_ctx.isRoute() ? 'text-green-lp-200' : 'text-red-lp-500'}`
                
                        }, _toDisplayString(_ctx.isRoute() ? "Active" : "Inactive"), 3)
                      ])
                    ])
                  ]),
                  _createVNode("div", _hoisted_35, [
                    _createVNode("div", _hoisted_36, _toDisplayString(_ctx.$t("userManagement.edit.createdAt")), 1),
                    _createVNode("div", _hoisted_37, _toDisplayString(_ctx.createdAt), 1),
                    _createVNode("div", _hoisted_38, _toDisplayString(_ctx.createdBy), 1)
                  ]),
                  _createVNode("div", _hoisted_39, [
                    _createVNode("div", _hoisted_40, _toDisplayString(_ctx.$t("userManagement.edit.lastUpdated")), 1),
                    _createVNode("div", _hoisted_41, _toDisplayString(_ctx.updateAt), 1),
                    _createVNode("div", _hoisted_42, _toDisplayString(_ctx.updateBy), 1)
                  ])
                ])
              ]))
        ], 64)),
    _withDirectives(_createVNode(_component_Modal, {
      onClose: _ctx.onCloseRoute,
      onSubmit: _ctx.changeRoute,
      title: 
      _ctx.isRoute()
        ? _ctx.$t('userManagement.edit.modalDeactivateTitle')
        : _ctx.$t('userManagement.edit.modalActivateTitle')
    ,
      message: 
      _ctx.isRoute()
        ? _ctx.$t('userManagement.edit.modalDeactivateMessage')
        : _ctx.$t('userManagement.edit.modalActivateMessage')
    ,
      image: "are-you-sure",
      textSuccess: 
      _ctx.isRoute()
        ? _ctx.$t('userManagement.edit.modalDeactivate')
        : _ctx.$t('userManagement.edit.modalActivate')
    ,
      textCancel: _ctx.$t('userManagement.edit.back'),
      class: "px-8"
    }, null, 8, ["onClose", "onSubmit", "title", "message", "textSuccess", "textCancel"]), [
      [_vShow, _ctx.openRoute]
    ]),
    _withDirectives(_createVNode(_component_Modal, {
      onSubmit: _ctx.onCloseSuccess,
      title: _ctx.$t('userManagement.edit.modalSuccessTitle'),
      message: `${_ctx.messageSuccess}`,
      image: "image-modal-success",
      textSuccess: _ctx.$t('userManagement.edit.ok'),
      class: "px-8"
    }, null, 8, ["onSubmit", "title", "message", "textSuccess"]), [
      [_vShow, _ctx.openSuccess]
    ]),
    _withDirectives(_createVNode(_component_Modal, {
      onSubmit: _ctx.handlerClose,
      onClose: _ctx.handlerCancelClose,
      title: _ctx.$t('userManagement.edit.modalLeaveTitle'),
      message: _ctx.$t('userManagement.edit.modalLeaveMessage'),
      image: "are-you-sure",
      textSuccess: _ctx.$t('userManagement.edit.leave'),
      textCancel: _ctx.$t('userManagement.edit.back'),
      class: "px-8"
    }, null, 8, ["onSubmit", "onClose", "title", "message", "textSuccess", "textCancel"]), [
      [_vShow, _ctx.isEditTerminated]
    ]),
    _withDirectives(_createVNode(_component_Modal, {
      onSubmit: _ctx._onEdit,
      onClose: _ctx.onCloseSave,
      title: _ctx.$t('userManagement.edit.modalConfirmTitle'),
      message: 
      _ctx.$t('userManagement.edit.modalConfirmMessage', {
        name: _ctx.dataDetail.username
      })
    ,
      image: "are-you-sure",
      textSuccess: _ctx.$t('userManagement.edit.save'),
      textCancel: _ctx.$t('userManagement.edit.back'),
      class: "px-8"
    }, null, 8, ["onSubmit", "onClose", "title", "message", "textSuccess", "textCancel"]), [
      [_vShow, _ctx.openSave()]
    ])
  ], 64))
}